import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const navItems = [{
  name: 'Home',
  path: '/'
}, {
  name: 'Meet Us',
  path: '/meet-us'
}, {
  name: 'Programs',
  path: '/programs'
}, {
  name: 'Contact',
  path: '/contact'
}];
export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  // Function to check if a link is active
  const isActive = path => {
    return location.pathname === path;
  };
  return <header className="w-full bg-white py-4 shadow-md z-50 sticky top-0" data-id="element-365">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between" data-id="element-366">
        <Link to="/" className="h-10 sm:h-12" data-id="element-367">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6enBba7nGTipGJpvGovp6X/IMG_1828.jpg" alt="The Legacy Lab - Wealth Acceleration" className="h-full w-auto object-contain" data-id="element-368" />
        </Link>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-10" data-id="element-369">
          {navItems.map(item => <Link key={item.name} to={item.path} className={`relative nav-link font-medium after:transition-all after:absolute after:left-1/2 after:-bottom-1 after:h-px after:bg-gold-500 after:-translate-x-1/2 ${isActive(item.path) ? 'text-gold-600 after:w-full' : 'text-gray-800 after:w-0 hover:after:w-full hover:text-gold-600'}`} data-id="element-370">
              {item.name}
            </Link>)}
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-371">
          {mobileMenuOpen ? <XIcon className="h-6 w-6 text-gold-500" data-id="element-372" /> : <MenuIcon className="h-6 w-6 text-gold-500" data-id="element-373" />}
        </button>
        {/* Mobile Navigation */}
        {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-white shadow-lg md:hidden" data-id="element-374">
            <nav className="flex flex-col px-4 py-4" data-id="element-375">
              {navItems.map(item => <Link key={item.name} to={item.path} className={`py-3 px-4 text-lg border-b border-gray-200 ${isActive(item.path) ? 'text-gold-500' : 'text-gray-800 hover:text-gold-500'} transition-colors`} onClick={() => setMobileMenuOpen(false)} data-id="element-376">
                  {item.name}
                </Link>)}
            </nav>
          </div>}
      </div>
    </header>;
}